import { createReducer } from 'typesafe-actions'
import { CompanyAction, CompanyState } from './types'
import { fetchCategoriesByCompanyHandle, fetchCompanyDetailsHandle, setSelectedCompanyHandle } from './handles'

const initialState: CompanyState = {
  companyPhones: [],
  selectedCompany: localStorage.getItem('devchat_app_selectedCompanyId') || null,
  selectedCompanyOwnerId: localStorage.getItem('devchat_app_selectedCompanyOwnerId') || null,
  isErrorOnLoadingSetSelectedCompany: false,
  isLoadingSetSelectedCompany: false,
  isSuccessOnLoadingSetSelectedCompany: false,
  isErrorOnLoadingFetchCompanyDetails: false,
  isLoadingFetchCompanyDetails: false,
  isSuccessOnLoadingFetchCompanyDetails: false,
  company: null,
  categories: [],
  isLoadingFetchCategoriesByCompany: false,
  isErrorOnLoadingFetchCategoriesByCompany: false,
  isSuccessOnLoadingFetchCategoriesByCompany: false
}

export const companyReducer = createReducer<CompanyState, CompanyAction>(initialState)
  .handleAction(setSelectedCompanyHandle.asyncAction.request, setSelectedCompanyHandle.request)
  .handleAction(setSelectedCompanyHandle.asyncAction.success, setSelectedCompanyHandle.success)
  .handleAction(setSelectedCompanyHandle.asyncAction.failure, setSelectedCompanyHandle.failure)
  .handleAction(fetchCompanyDetailsHandle.asyncAction.request, fetchCompanyDetailsHandle.request)
  .handleAction(fetchCompanyDetailsHandle.asyncAction.success, fetchCompanyDetailsHandle.success)
  .handleAction(fetchCompanyDetailsHandle.asyncAction.failure, fetchCompanyDetailsHandle.failure)
  .handleAction(fetchCategoriesByCompanyHandle.asyncAction.request, fetchCategoriesByCompanyHandle.request)
  .handleAction(fetchCategoriesByCompanyHandle.asyncAction.success, fetchCategoriesByCompanyHandle.success)
  .handleAction(fetchCategoriesByCompanyHandle.asyncAction.failure, fetchCategoriesByCompanyHandle.failure)
